import { couponsSavingsQueryOptions } from '@/features/shop/services/Coupons/queries'
import { type ClipCouponResponse } from '@/features/shop/services/Coupons/types'
import { useCurrentActiveOrderId } from '@/features/shop/state/SelectedActiveOrder/hooks'
import { normalizeClippedCoupon } from '@/features/shop/utils/normalizeCoupon'
import { apiPost } from '@/features/shared/utils/dataFetching'
import { useStoreParams } from '@/features/shared/utils/dataFetching/storeParams'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useUserId } from '@/features/account/services/User/hooks'

export const useMutationClipCoupon = () => {
  const storeParams = useStoreParams()
  const queryClient = useQueryClient()
  const userId = useUserId() || 0
  const currentActiveOrderId = useCurrentActiveOrderId()

  return useMutation({
    mutationFn: async (couponId: string) => {
      const data = await apiPost<ClipCouponResponse>({
        config: {
          url: '/coupon_service/v1/coupons.clip',
          params: {
            ...storeParams,
            coupon_id: couponId,
            clip_source: 'web',
          },
        },
        fetcherName: 'useMutationClipCoupon',
      })
      const { clipped_coupons: clippedCoupons = [] } = data
      return clippedCoupons.map(normalizeClippedCoupon)[0]
    },
    onSuccess: (coupon) => {
      queryClient.setQueryData(
        couponsSavingsQueryOptions({
          currentActiveOrderId,
          storeParams,
          userId,
        }).queryKey,
        (prevCoupons) => ({
          ...prevCoupons,
          ...(coupon?.couponId && { [coupon.couponId]: coupon }),
        }),
      )
    },
  })
}
